import React, { useEffect, useState } from "react";
import SmallLogo from "../assets/logo/small-logo.svg";
import GameCategoryCard from "../components/GameCategoryCard";
import { AllTicketsCount, gameCategoryCards } from "../constants/const";
import { useNavigate } from "react-router";
import PlayIcon from "../assets/icons/play-icon.svg";
import { getLevelPriceNano } from "../blockchain/lotteryClient";
import ProgressChartMini from "../components/ProgressChartMini";
import { getMegaJackpotInfo } from "../blockchain/lotteryClient";
import { fromNano } from "@ton/core";
import { Spin } from "antd";

function AuthLayout() {
    const navigate = useNavigate();
    const [isLoadingMega, setIsLoadingMega] = useState(true);
    const [isLoadingPrices, setIsLoadingPrices] = useState(true);

    const isLoading = isLoadingMega || isLoadingPrices;
    const [megaBudget, setMegaBudget] = useState<number | null>(null);
    const [priceArray, setPriceArray] = useState<number[]>([]);
    const [megaThreshold, setMegaThreshold] = useState<number>(0);
    const [megaPercent, setMegaPercent] = useState<number>(0);
    const cards = gameCategoryCards.map((card, index) => ({
        ...card,
        ticketPrice: priceArray[index] ?? null,
    }));

    const [isCompetitionClose, setIsCompetitionClose] = useState(true)

    useEffect(() => {
        let cancelled = false;

        async function loadMega() {
            try {
                setIsLoadingMega(true);

                const info: any = await getMegaJackpotInfo();
                if (!info || cancelled) return;

                const balanceStr = fromNano(info.balance.toString());
                const thresholdStr = fromNano(info.threshold.toString());

                const balance = Number(balanceStr);
                const threshold = Number(thresholdStr);


                setMegaBudget(balance);
                setMegaThreshold(threshold);

                const percent = threshold > 0
                    ? Math.min(balance / threshold, 1)
                    : 0;

                setMegaPercent(percent);

            } catch (e) {
                console.error("Failed to load mega jackpot", e);
            } finally {
                if (!cancelled) setIsLoadingMega(false);
            }
        }

        loadMega();

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        let cancelled = false;

        async function loadPrices() {
            try {
                setIsLoadingPrices(true);

                const levels = [0, 1, 2];

                const pricesNano = await Promise.all(
                    levels.map(lvl => getLevelPriceNano(lvl))
                );

                if (cancelled) return;

                const pricesTon = pricesNano.map(p => Number(p) / 1e9);

                setPriceArray(pricesTon);
            } catch (e) {
                console.error("Failed to load prices", e);
            } finally {
                if (!cancelled) setIsLoadingPrices(false);
            }
        }

        loadPrices();

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        setIsCompetitionClose(true)
    }, [])

    const handleOpenGame = (item: string, index: number) => {
        switch (index) {
            case 0:
                localStorage.setItem("gameName", "regular-game");
                navigate("/jackpot");
                break;
            case 1:
                localStorage.setItem("gameName", "standard-game");
                navigate("/jackpot");
                break;
            case 2:
                localStorage.setItem("gameName", "premium-game");
                navigate("/jackpot");
                break;
            default:
                navigate("*");
        }
    };

    const formatTon = (value: number, decimals = 4) => {
        return value
            .toFixed(decimals)
            .replace(/\.?0+$/, "");
    };
    const handleMegaJackpotPage = () => navigate("/mega-jackpot");

    return (
        <div className="auth-layout">
            {isLoading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(0, 0, 0, 0.65)",
                        zIndex: 9999
                    }}
                >
                    <Spin size="large" />
                </div>
            )}
            <img src={SmallLogo} alt="logo" width="129" height="73" />

            <div className="games-category">
                <div className="games-category_header">
                    <div className="games-category_header__title">
                        Игры
                    </div>
                    <div
                        className="games-category_header__link"
                        onClick={() => navigate("/")}
                    >
                        <img
                            src={PlayIcon}
                            alt="icon"
                            className="games-category_header__link___icon"
                        />
                        <div className="games-category_header__link___text">
                            Пересмотреть видеоуроки?
                        </div>
                    </div>
                </div>

                {cards.map((cardItem, index) => (
                    <GameCategoryCard
                        key={cardItem.name}
                        gameIcon={cardItem.icon}
                        name={cardItem.name}
                        subTitle={cardItem.subTitle}
                        ticketPrice={cardItem.ticketPrice}
                        func={() => handleOpenGame(cardItem.name, index)}
                    />
                ))}

                {isCompetitionClose ?
                    <div className="mega-jackpot-game-card-process" onClick={handleMegaJackpotPage}>
                        <div className="mega-jackpot-game-card-process_left">
                            <div className="mega-jackpot-game-card-process_left__title">
                                Мега Джекпот
                            </div>
                            <div className="mega-jackpot-game-card-process_left__content">
                                Соревнование стартует после достижения{" "}
                                {megaThreshold > 0 ? `${megaThreshold} TON` : "загрузка..."}
                            </div>
                        </div>
                        <div>
                            <ProgressChartMini
                                percent={megaPercent}
                                amount={formatTon(megaBudget ?? 0, 4)}
                            />
                        </div>
                    </div> :
                    <div className="mega-jackpot-game-card-completed" onClick={handleMegaJackpotPage}>
                        <div className="mega-jackpot-game-card-completed_right">
                            <div className="mega-jackpot-game-card-completed_right__title">
                                Мега Джекпот
                            </div>
                            <div className="mega-jackpot-game-card-completed_right__content">
                                Стоимость билета: {10} TON
                            </div>
                        </div>
                    </div>
                }

            </div>
        </div>
    );
}

export default AuthLayout;
